import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import OnboardingWizard from './OnboardingWizard';

const OnboardingEditPage: React.FC = () => {
  const { t } = useTranslation();
  const { appId } = useParams<{ appId: string }>();

  if (!appId) {
    return <Alert severity="error" sx={{ m: 3 }}>Missing project id.</Alert>;
  }

  return (
    <Box sx={{ flexGrow: 1, minWidth: 0, height: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column', p: { xs: 1.5, sm: 2 } }}>
      <Box sx={{ mb: 1.5, flexShrink: 0 }}>
        <Typography variant="h5" fontWeight={700}>{t('onboarding.form.editTitle')}</Typography>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <OnboardingWizard mode="edit" appId={appId} />
      </Box>
    </Box>
  );
};

export default OnboardingEditPage;
